import * as Sentry from "@sentry/react";

export const getSentry = () => Sentry;
